import { useCallback } from 'react';

import { openTalkativeUI } from '@phx/talkative';

import { useBrandContext } from '../contexts/BrandProvider';

export const useContactSupport = () => {
    const { brandId } = useBrandContext();

    return useCallback(() => {
        if (brandId === 'LillyDirect') {
            window.open(
                `${import.meta.env.VITE_LILLY_UNAUTH_URL}/support`,
                '_blank'
            );
        } else {
            openTalkativeUI();
        }
    }, [brandId]);
};
